module.exports = __webpack_public_path__ + "static/media/HCMM505.24bfac32.jpg";